import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";

export const createModule = (
  language: string,
  payload: {
    name: string;
    description: string;
    programming_language: string;
    owner_id: number;
    language: string;
    is_deprecated: boolean;
    origin_program_id: number;
    purpose: string;
    image_url?: string;
  },
  setLoading: Function,
  onSuccess: Function,
  showAlert?: Function,
  popAlert?: Function
) => {
  setLoading(true);

  ApiService.post("modules", payload)
    .then((resp) => onSuccess(resp.data))
    .catch((error) => {
      const apiError = (error as any)?.data;

      const message = apiError?.error?.message || translate(language, "PAGES.MODULES.CREATE.ERRORS.CREATION");

      showAlert?.({
        type: "danger",
        title: translate(language, "PAGES.MODULES.CREATE.ALERTS.ERROR_TITLE"),
        message,
        clickOutsideToClose: true,
        buttons: [
          {
            label: translate(language, "GLOBAL.CLOSE"),
            variant: "danger",
            onClick: () => popAlert?.(),
          },
        ],
        extraContent: apiError ? (
          <pre className="text-start off-white-background p-2 rounded border">{JSON.stringify(apiError, null, 2)}</pre>
        ) : null,
      });
    })
    .finally(() => setLoading(false));
};

export const fetchPrograms = (language: string, setPrograms: Function, setLoading: Function) => {
  setLoading(true);

  ApiService.get("programs")
    .then((resp) => setPrograms(resp.data.programs))
    .catch((error) => {
      console.error("Error loading programs:", error);
      alert(translate(language, "PAGES.MODULES.CREATE.ERRORS.LOADING_PROGRAM"));
    })
    .finally(() => setLoading(false));
};
